/**
 * Asynchronously loads the component for VerifySmsLinkPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
